/* ==========================================================================
   BSD — Options de variantes affichées directement dans la carte produit
   (remplace le panneau .wb_popup_variant du thème)

   Reprend la logique validée sur les cards Boost :
     - comparaison normalisée (espaces insécables, entités, casse)
     - règle de disponibilité EN CASCADE : une valeur n'est contrainte que par
       les options précédentes, donc aucune variante disponible ne devient
       inatteignable
     - réajustement automatique des options suivantes après un clic
     - changement de l'image de la carte selon la variante
     - prix recalculé en respectant votre logique HT régionale
   ========================================================================== */
(function () {
  'use strict';

  var CONFIG = {
    // Valeurs indisponibles : true = masquées, false = grisées (comme aujourd'hui)
    hideUnavailable: false,
    // Réajuster les options suivantes après un clic
    repairForward: true,
    // Que faire d'une option suivante devenue invalide :
    //   'clear' -> la désélectionner (cohérent avec « rien de sélectionné
    //              par défaut » : on ne choisit jamais à la place du client)
    //   'first' -> basculer sur la première valeur disponible
    repairMode: 'clear',
    // Mettre à jour le prix affiché sur la carte
    updatePrice: true,
    // Mettre à jour l'image de la carte
    updateImage: true,
    // Ajouter ?variant=<id> aux liens de la carte
    updateLinks: true,

    labels: {
      add: 'Ajouter au panier',
      // Affiché tant que toutes les options ne sont pas choisies
      incomplete: 'Choisir les options',
      soldOut: 'Épuisé',
      unavailable: 'Indisponible'
    },

    debug: false
  };

  var ROOT_SELECTOR = '[data-bsd-card-options]';

  function log() {
    if (!CONFIG.debug && !window.BSD_CARD_DEBUG) return;
    try {
      console.log.apply(console, ['[bsd-card]'].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  /* ----------------------------------------------------------------------
     Utilitaires
     ---------------------------------------------------------------------- */
  function decodeEntities(str) {
    if (typeof str !== 'string' || str.indexOf('&') === -1) return str;
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  function key(value) {
    return decodeEntities(String(value == null ? '' : value))
      .replace(/[    ]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  /* Reproduit exactement le filtre `money` de Shopify à partir du format
     du shop, pour que le prix recalculé soit formaté comme celui rendu
     côté serveur. */
  function formatMoney(cents, format) {
    var formatString = format || '{{amount}} €';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholder);
    if (!match) return formatString;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholder, value);
  }

  /* Les mêmes nettoyages que dans card-product.liquid */
  function cleanSuffixes(text) {
    return String(text)
      .replace('€ TTC', '€')
      .replace(' TTC', '')
      .replace(' + IVA', '');
  }

  var IMAGE_WIDTHS = [165, 360, 533, 720, 940];

  function withImageWidth(url, width) {
    if (!url) return '';
    var clean = String(url).replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* ----------------------------------------------------------------------
     Lecture de la carte
     ---------------------------------------------------------------------- */
  function readBlock(block) {
    if (block.__bsd) return block.__bsd;

    var script = block.querySelector('script.bsd-card-variants');
    if (!script) return null;

    var raw;
    try {
      raw = JSON.parse(script.textContent);
    } catch (e) {
      log('JSON de variantes illisible', e);
      return null;
    }

    var variants = (raw || []).map(function (v) {
      var options = [v.option1, v.option2, v.option3].filter(function (o) {
        return o != null && o !== '';
      });
      return {
        id: String(v.id),
        title: v.title || '',
        available: !!v.available,
        price: v.price,
        compareAtPrice: v.compare_at_price,
        image: (v.featured_image && v.featured_image.src) || '',
        options: options,
        optionKeys: options.map(key)
      };
    });

    var groups = [].slice.call(block.querySelectorAll('.bsd-card-option')).map(function (el, index) {
      var inputs = [].slice.call(el.querySelectorAll('input[type="radio"]'));
      return {
        index: index,
        el: el,
        inputs: inputs,
        getSelected: function () {
          var checked = el.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : null;
        },
        setSelected: function (value) {
          inputs.forEach(function (input) {
            if (key(input.value) === key(value)) input.checked = true;
          });
        }
      };
    });

    var data = {
      block: block,
      card: block.closest('.card-wrapper') || block.closest('wb-card-variant') || block.parentNode,
      variants: variants,
      groups: groups,
      divisor: parseFloat(block.getAttribute('data-price-divisor')) || 1,
      suffix: block.getAttribute('data-price-suffix') || '',
      moneyFormat: block.getAttribute('data-money-format') || '',
      handle: block.getAttribute('data-product-url') || ''
    };

    block.__bsd = data;
    return data;
  }

  /* ----------------------------------------------------------------------
     Disponibilité — règle en cascade
     ---------------------------------------------------------------------- */
  function selectedKeysOf(data) {
    return data.groups.map(function (g) {
      var v = g.getSelected();
      return v == null ? null : key(v);
    });
  }

  function isValueAvailable(data, optionIndex, value, selectedKeys) {
    var k = key(value);
    return data.variants.some(function (v) {
      if (!v.available) return false;
      if (v.optionKeys[optionIndex] !== k) return false;
      for (var i = 0; i < optionIndex; i++) {
        if (selectedKeys[i] && v.optionKeys[i] !== selectedKeys[i]) return false;
      }
      return true;
    });
  }

  function findVariant(data, selectedKeys) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      var ok = true;
      for (var j = 0; j < selectedKeys.length; j++) {
        if (!selectedKeys[j] || v.optionKeys[j] !== selectedKeys[j]) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return null;
  }

  /* Réajuste les options SUIVANTES uniquement : le choix de l'utilisateur
     et les options précédentes ne sont jamais modifiés.
     Une option suivante qui n'a pas encore été choisie est laissée vide. */
  function repairForward(data, changedIndex) {
    for (var j = changedIndex + 1; j < data.groups.length; j++) {
      var selectedKeys = selectedKeysOf(data);
      var current = data.groups[j].getSelected();

      if (!current) continue; // rien de choisi : on ne choisit pas à sa place
      if (isValueAvailable(data, j, current, selectedKeys)) continue;

      if (CONFIG.repairMode === 'clear') {
        data.groups[j].inputs.forEach(function (input) {
          input.checked = false;
        });
        log('option ' + (j + 1) + ' désélectionnée (combinaison impossible)');
        continue;
      }

      var inputs = data.groups[j].inputs;
      for (var i = 0; i < inputs.length; i++) {
        if (isValueAvailable(data, j, inputs[i].value, selectedKeys)) {
          data.groups[j].setSelected(inputs[i].value);
          log('option ' + (j + 1) + ' réajustée sur', inputs[i].value);
          break;
        }
      }
    }
  }

  /* ----------------------------------------------------------------------
     Application à la carte
     ---------------------------------------------------------------------- */
  /* Maintient les classes du thème : `active` sur la valeur choisie,
     `disabled` sur les valeurs indisponibles — comme le faisait le picker
     dans la pop-up, pour que le CSS existant du thème s'applique. */
  function syncOptionStates(data, selectedKeys) {
    data.groups.forEach(function (group) {
      group.inputs.forEach(function (input) {
        var available = isValueAvailable(data, group.index, input.value, selectedKeys);
        input.disabled = !available;

        var label =
          group.el.querySelector('label[for="' + cssEscape(input.id) + '"]') ||
          input.nextElementSibling;
        if (!label || label.tagName !== 'LABEL') return;

        label.classList.toggle('disabled', !available);
        label.classList.toggle('active', !!input.checked);
        if (CONFIG.hideUnavailable) label.classList.toggle('bsd-hidden', !available);
      });
    });
  }

  function cssEscape(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/([^\w-])/g, '\\$1');
  }

  function updateFormVariant(data, variant) {
    if (!variant) return;
    var card = data.card;

    // C'est ce <select name="id" form="..."> qui alimente réellement le formulaire
    var select = card.querySelector('select[name="id"]');
    if (select) select.value = variant.id;

    card.querySelectorAll('input[name="id"].product-variant-id').forEach(function (input) {
      input.value = variant.id;
    });
  }

  function updateButton(data, variant, selectedKeys) {
    var button = data.card.querySelector('product-form button[name="add"], .add-to-cart__submit');
    if (!button) return;
    var span = button.querySelector('span:not(.sold-out-message)') || button;

    var incomplete = selectedKeys.some(function (k) {
      return !k;
    });

    if (variant && variant.available) {
      button.removeAttribute('disabled');
      button.disabled = false;
      span.textContent = CONFIG.labels.add;
      return;
    }

    button.setAttribute('disabled', 'disabled');
    button.disabled = true;

    if (incomplete) {
      // Toutes les options ne sont pas encore choisies
      span.textContent = CONFIG.labels.incomplete;
    } else {
      span.textContent = variant ? CONFIG.labels.soldOut : CONFIG.labels.unavailable;
    }
  }

  function moneyFor(data, cents) {
    if (cents == null) return '';
    var adjusted = data.divisor && data.divisor !== 1 ? cents / data.divisor : cents;
    return cleanSuffixes(formatMoney(adjusted, data.moneyFormat)) + data.suffix;
  }

  function updatePrice(data, variant) {
    if (!CONFIG.updatePrice) return;

    // innerHTML et pas textContent : le suffixe régional et certains formats
    // monétaires Shopify contiennent du balisage (<span class="money">…),
    // qui s'afficherait littéralement en texte sinon.
    var priceEl = data.card.querySelector('.card_sale_price');
    var compareEl = data.card.querySelector('.card_compare_price');

    if (priceEl && priceEl.__bsdOriginal == null) priceEl.__bsdOriginal = priceEl.innerHTML;
    if (compareEl && compareEl.__bsdOriginal == null) compareEl.__bsdOriginal = compareEl.innerHTML;

    // Rien de sélectionné : on remet le prix du produit de base
    // (« À partir de … » rendu par Liquid).
    if (!variant) {
      if (priceEl) priceEl.innerHTML = priceEl.__bsdOriginal;
      if (compareEl) {
        compareEl.innerHTML = compareEl.__bsdOriginal;
        compareEl.classList.remove('bsd-hidden');
      }
      return;
    }

    if (priceEl) priceEl.innerHTML = moneyFor(data, variant.price);

    if (compareEl) {
      if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        compareEl.innerHTML = moneyFor(data, variant.compareAtPrice);
        compareEl.classList.remove('bsd-hidden');
      } else {
        compareEl.classList.add('bsd-hidden');
      }
    }
  }

  function updateImage(data, variant) {
    if (!CONFIG.updateImage) return;

    var img =
      data.card.querySelector('.card__media .product__media-item img.motion-reduce') ||
      data.card.querySelector('.card__media img');
    if (!img) return;

    if (!img.__bsdOriginal) {
      img.__bsdOriginal = {
        src: img.getAttribute('src') || '',
        srcset: img.getAttribute('srcset') || ''
      };
    }

    var url = variant && variant.image ? variant.image : '';
    if (url) {
      var next = withImageWidth(url, 533);
      if (img.getAttribute('src') !== next) {
        img.setAttribute('src', next);
        img.setAttribute(
          'srcset',
          IMAGE_WIDTHS.map(function (w) {
            return withImageWidth(url, w) + ' ' + w + 'w';
          }).join(', ')
        );
      }
      data.card.classList.add('bsd-has-variant-image');
    } else {
      img.setAttribute('src', img.__bsdOriginal.src);
      if (img.__bsdOriginal.srcset) img.setAttribute('srcset', img.__bsdOriginal.srcset);
      else img.removeAttribute('srcset');
      data.card.classList.remove('bsd-has-variant-image');
    }
  }

  function updateLinks(data, variant) {
    if (!CONFIG.updateLinks || !variant || !data.handle) return;
    var base = data.handle.split('?')[0];
    data.card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      a.setAttribute('href', base + '?variant=' + variant.id);
    });
  }

  /* ----------------------------------------------------------------------
     Cycle principal
     ---------------------------------------------------------------------- */
  function update(data, changedIndex) {
    if (CONFIG.repairForward && changedIndex != null) repairForward(data, changedIndex);

    var selectedKeys = selectedKeysOf(data);
    var variant = findVariant(data, selectedKeys);
    log('sélection', selectedKeys, '->', variant ? variant.id : 'aucune');

    syncOptionStates(data, selectedKeys);
    updateFormVariant(data, variant);
    updateButton(data, variant, selectedKeys);
    updatePrice(data, variant);
    updateImage(data, variant);
    updateLinks(data, variant);
  }

  /* Le dégradé de droite n'a de sens que si la ligne déborde réellement */
  function flagScrollable(block) {
    block.querySelectorAll('.bsd-card-option__values').forEach(function (row) {
      row.classList.toggle('bsd-is-scrollable', row.scrollWidth > row.clientWidth + 2);
    });
  }

  function bind(block) {
    if (block.__bsdBound) return;
    var data = readBlock(block);
    if (!data || !data.groups.length || !data.variants.length) return;
    block.__bsdBound = true;

    if (data.card && data.card.classList) data.card.classList.add('bsd-inline-options');

    block.addEventListener('change', function (event) {
      var group = event.target.closest ? event.target.closest('.bsd-card-option') : null;
      var index = group ? parseInt(group.getAttribute('data-option-index'), 10) : null;
      update(data, isNaN(index) ? null : index);
    });

    update(data, null);
    flagScrollable(block);
    log('carte initialisée', data.variants.length + ' variantes');
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll(ROOT_SELECTOR).forEach(flagScrollable);
    }, 150);
  });

  function init(root) {
    (root || document).querySelectorAll(ROOT_SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Cartes injectées après coup (pagination AJAX, recommandations, filtres)
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(ROOT_SELECTOR)) bind(node);
        else if (node.querySelectorAll) init(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ----------------------------------------------------------------------
     Diagnostic
     ---------------------------------------------------------------------- */
  window.bsdCardAudit = function (limit) {
    var blocks = [].slice.call(document.querySelectorAll(ROOT_SELECTOR), 0, limit || 3);
    blocks.forEach(function (block) {
      var data = readBlock(block);
      if (!data) return;

      var selectedKeys = selectedKeysOf(data);
      var rows = [];
      data.groups.forEach(function (group) {
        group.inputs.forEach(function (input) {
          rows.push({
            option: group.index + 1,
            valeur: input.value,
            'dispo (cascade)': isValueAvailable(data, group.index, input.value, selectedKeys),
            'désactivé (DOM)': input.disabled
          });
        });
      });
      console.table(rows);

      var unreachable = data.variants.filter(function (target) {
        if (!target.available) return false;
        var keys = data.groups.map(function () {
          return null;
        });
        for (var i = 0; i < data.groups.length; i++) {
          if (!isValueAvailable(data, i, target.options[i], keys)) return true;
          keys[i] = target.optionKeys[i];
        }
        return false;
      });
      console.log(
        unreachable.length
          ? '[bsd-card] variantes inatteignables : ' + unreachable.map(function (v) { return v.title; }).join(', ')
          : '[bsd-card] toutes les variantes disponibles sont atteignables.'
      );
    });
  };
})();